<template>
	<div>
		<div>
			<Input labelText="Location Name" />
		</div>
		<div>
			<ButtonClassic labelText="Add" />
			<ButtonClassic labelText="Cancel" />
		</div>
	</div>
</template>

<script>
import viewMixin from '@/mixins/view-mixin';
import ButtonClassic from '@/components/forms/button/button-classic.vue';

export default {
	name: 'CompanyLocationAdd',
	mixins: [viewMixin],
	components: {
		ButtonClassic
	},
	created() {},
	computed: {},
	methods: {}
};
</script>

<style lang="scss" scoped></style>
